export default __webpack_public_path__ + "static/sh_opengraph-c1d1682ac107f06491fe7005b8499714.jpg";